import { authTypes } from '../auth/types'
import { ClientPropertiesActions, ClientPropertiesType, clientPropertiesTypes } from './types'

const initialState: ClientPropertiesType = null

const reducer = (state = initialState, action: ClientPropertiesActions): ClientPropertiesType => {
  const { type, payload } = action as any

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case clientPropertiesTypes.SET_CLIENT_PROPERTIES: {
      return payload
    }

    default:
      return state
  }
}

export default reducer

